
import { Alert, Button, Col, Modal, Row, Select, Table } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { EditOutlined, DeleteOutlined, PlusOutlined, SyncOutlined, LoadingOutlined, DownloadOutlined } from '@ant-design/icons';
import { apiCall } from '../../API/RestApi';
import Search from 'antd/es/input/Search';
import { modalError } from '../../Component/Modal/ModalLayout';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { currencyFormat } from '../../Utils/formatCurrency';
import { exportProductMasterExcel } from '../../Utils/Excel/ProductMasterExportExcel';


function ListProduct() {
    const token = useSelector((state) => state.user.token);
    //LIBRARY
    const navigate = useNavigate();
    const [data, setData] = useState();
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState(false);
    const [isExportModalOpen, setIsExportModalOpen] = useState(false);
    const [exportCategory, setExportCategory] = useState('all');
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [loadingExport, setLoadingExport] = useState(false);

    // //Parameter
    const titlePage = 'Produk';
    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
             sorter: false,
            key: "no",
            render: (id, record, index) => { ++index; return (page.pagination.current - 1) * 10 + index },
        },
        {
            title: 'Kode Barang',
            dataIndex: 'product_code',
            key: "product_code",
             sorter: false,
        },
        {
            title: 'Barcode',
            dataIndex: 'barcode',
            key: "barcode",
             sorter: false,
            render: (text, record) => {
                if (record.variant_products.length > 0)
                    return record.variant_products[0].barcode_code !== null ? record.variant_products[0].barcode_code : '-';
                else
                    return '-';
            }
        },
        {
            title: 'Nama Barang',
            dataIndex: 'product_name',
            key: "product_name",
             sorter: false,
        },
        {
            title: 'Kategori',
            dataIndex: 'category',
            key: "category",
             sorter: false,
        },
        {
            title: 'Harga',
            dataIndex: 'price',
            key: "price",
             sorter: false,
            render: (text, record) => {
                if (record.variant_products.length > 0)
                    return currencyFormat(record.variant_products[0].price);
                else
                    return '-';
            }
        },
        {
            title: 'Status',
            dataIndex: 'isActive',
            key: "isActive",
             sorter: false,
            render: (text, record) => {
                return (
                    <>
                        {
                            record.isActive === true ?
                                <b>Aktif</b>
                                :
                                <b>Tidak Aktif</b>
                        }
                    </>
                )
            }
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => {
                return (
                    <>
                        <Button type="primary" style={{ marginRight: 10 }} onClick={() => navigate('/formproduct', { state: { item: record } })}>
                            <EditOutlined />
                            <b style={{ marginLeft: 5 }}>Ubah</b>
                        </Button>
                        <Button type="primary" danger onClick={() => modalDeleteData(record)}>
                            <DeleteOutlined />
                            <b style={{ marginLeft: 5 }}>Hapus</b>
                        </Button>
                    </>
                );
            },
        },
    ];

    useEffect(() => {
        getApi('/product?search=' + search + '&page=' + page.pagination.current);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(page), isAlert]);

    const getApi = (url) => {
        setLoading(true);
        const dataReq = {
            method: "GET",
            url: url,
            data: {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === 200) {
                var row = [];
                var item = res.data.rows;
                for (let i = 0; i < item.length; i++) {
                    //Satuan
                    var product_satuan = item[i].product_satuan;
                    var satuan = product_satuan != null ? product_satuan.satuan : null;
                    var rasio_satuan = product_satuan != null ? product_satuan.rasio_satuan : null;
                    row.push({
                        product_id: item[i].product_id,
                        product_code: item[i].product_code,
                        product_name: item[i].product_name,
                        category: item[i].category != null ? item[i].category.category_name : null,
                        category_id: item[i].category != null ? item[i].category.category_id : null,
                        satuan: satuan,
                        rasio_satuan: rasio_satuan,
                        description: item[i].description,
                        isActive: item[i].isActive,
                        image: item[i].image,
                        variant_products: item[i].variant_products
                    })
                }
                setData(row);
                setPage({
                    ...page,
                    pagination: {
                        ...page.pagination,
                        total: res.data.count
                    }
                });
                setLoading(false);
                setLoadingBtn(false);
            } else {
                setLoading(false);
                setLoadingBtn(false);
                console.log(res.message);
            }
        }).catch((e) => {
            setLoading(false);
            setLoadingBtn(false);
            console.log(e.message);
        })
    }

    const postApi = (method, values) => {
        setLoading(true);
        setIsAlert(false);

        var url = '/product';
        if (method === 'DELETE') {
            url = '/product/' + values.product_id;
        }
        const dataReq = {
            method: method,
            url: url,
            data: {
                data: values,
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === 200) {
                setLoading(false);
                setIsAlert(true);
                setTextAlert(res.message);
            } else {
                setLoading(false);
                modalError(res.message);
            }
        }).catch((e) => {
            setLoading(false);
            console.log(e.message);
        })
    }

    const modalDeleteData = (v) => {
        Modal.confirm({
            title: 'NOTICE',
            content: 'Anda ingin menghapus data ini?',
            onOk: () => postApi('DELETE', v),
        });
    }

    const handleTableChange = (pagination, filters, sorter) => {
        setPage({
            pagination,
            filters,
            ...sorter,
        });
        if (pagination.pageSize !== page.pagination?.pageSize) {
            setData([]);
        }
    };

    const searchData = (value) => {
        setSearch(value);
        setPage({
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
    }

    const syncProductAccurate = () => {
        setLoadingBtn(true);
        setLoading(true);
        getApi('/accurate/loaditem?page=1&pageSize=100');
    }

    const openExportModal = async () => {
        setExportCategory('all');
        setIsExportModalOpen(true);

        if (categoryOptions.length > 0) return;

        try {
            const res = await apiCall({
                method: 'GET',
                url: '/category?nopage=1',
                data: {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            });

            if (res.status === 200) {
                setCategoryOptions(res.data || []);
            } else {
                modalError(res.message || 'Gagal mengambil data kategori.');
            }
        } catch (error) {
            modalError('Gagal mengambil data kategori.');
        }
    };

    const handleExportProduct = async () => {
        setLoadingExport(true);
        try {
            const categoryQuery = exportCategory === 'all' ? '' : `&categoryId=${exportCategory}`;
            const res = await apiCall({
                method: 'GET',
                url: `/product?nopage=1${categoryQuery}`,
                data: {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            });

            if (res.status !== 200) {
                modalError(res.message || 'Gagal mengambil data produk untuk export.');
                return;
            }

            const products = res.data?.rows || [];
            const selectedCategory = categoryOptions.find(
                (category) => String(category.category_id) === String(exportCategory)
            );
            const categoryLabel = exportCategory === 'all'
                ? 'Semua Kategori'
                : selectedCategory?.category_name || 'Kategori';

            exportProductMasterExcel(products, categoryLabel);
            setIsExportModalOpen(false);
        } catch (error) {
            modalError('Terjadi kesalahan saat export data produk.');
        } finally {
            setLoadingExport(false);
        }
    };

    return (
        <>
            <Helmet>
                <title>{titlePage}</title>
            </Helmet>
            {isAlert && <Alert message={textAlert} type="success" banner closable afterClose={() => setIsAlert(false)} />}
            <h3>Daftar Produk</h3>
            <Row>
                <Col span={12} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                    <Button
                        className="master-sync-button"
                        style={{ marginBottom: 10, marginRight: 10 }}
                        type="primary"
                        icon={loadingBtn ? <LoadingOutlined /> : <SyncOutlined />}
                        onClick={() => syncProductAccurate()}
                    >
                        Sync Accurate
                    </Button>
                    <Search
                        disabled={loadingBtn}
                        placeholder="Pencarian"
                        allowClear
                        enterButton="Search"
                        size="medium"
                        onSearch={searchData}
                    />
                </Col>

                <Col span={12} style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }} >
                    <Button
                        disabled={loadingBtn}
                        style={{ marginBottom: 10 }}
                        icon={<DownloadOutlined />}
                        onClick={openExportModal}
                    >
                        Export Data
                    </Button>
                    <Button disabled={loadingBtn} style={{ marginBottom: 10 }} type="primary" onClick={() => { navigate('/formproduct') }}>
                        <PlusOutlined />
                        <b style={{ marginLeft: 5 }}>Tambah Produk</b>
                    </Button>
                </Col>
            </Row>
            <Table
                size="middle"
                columns={columns}
                dataSource={data}
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
            />

            <Modal
                title="Export Data Produk"
                open={isExportModalOpen}
                onCancel={() => setIsExportModalOpen(false)}
                onOk={handleExportProduct}
                okText="Export"
                cancelText="Batal"
                confirmLoading={loadingExport}
                destroyOnClose
            >
                <div style={{ marginBottom: 8, fontWeight: 600 }}>Kategori</div>
                <Select
                    value={exportCategory}
                    onChange={setExportCategory}
                    style={{ width: '100%' }}
                    showSearch
                    optionFilterProp="label"
                    options={[
                        { value: 'all', label: 'Semua Kategori' },
                        ...categoryOptions.map((category) => ({
                            value: String(category.category_id),
                            label: category.category_name,
                        })),
                    ]}
                />
            </Modal>
        </>
    );
}

export default ListProduct;